import dayjs from 'dayjs';

export const formatDate = (dateString) => {
    const formattedDate = dayjs(dateString);
    return formattedDate.format("YYYY-MM-DD");
};
